module.exports = __webpack_public_path__ + "static/resume-e94678acc25c88fbae9a02537414a62a.pdf";